import { Link } from "react-router-dom";

import IcoArrowThin from "../../images/svg/IcoArrowThin";

const JoinForces = () => {
  return (
    <>
      <section className="about-join">
        <div className="containerFull">
          <h3>Need help improving an existing software platform?</h3>
          <p className="about-join-copy">Tell us about your platform, your backlog, or the software changes your current team is struggling to deliver.</p>
          <Link to={`/contact-us`} className='see-more-btn'>
              <span>Book a Backlog Review</span> 
              <IcoArrowThin color="var(--midnight-blue)" />
          </Link>
        </div>
      </section>

    </>
  );
};

export default JoinForces;
